import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {NgxsModule} from '@ngxs/store';
import {environment} from '@environments/environment';
import {AuthState} from './auth/auth.state';
import {UserState} from './user/user.state';
import {PageTemplateState} from './page-template/page-template.state';
import {EventState} from './ott-event/event.state';
import {LinkedEventsState} from './linked-ott-events/linked-events.state';
import {PlaylistState} from './playlist/playlist.state';
import {FormatState} from './format/format.state';
import {OfferItemsState} from './offer-items/offer-items.state';
import {SearchEventsState} from './search-ott-events/search-ott-events.state';
import {EntitlementsState} from './entitlements/entitlements.state';
import {FeaturedEventsState} from './featured-ott-events/featured-events.state';
import {BlockedCountiresState} from './blocked-countries/blocked-countries.state';
import {SeasonsState} from './seasons/seasons.state';
import {StagesState} from './stages/stages.state';
import {StandingsState} from './standings/standings.state';
import {ClubsState} from './clubs/clubs.state';
import {CompetitionsState} from './competitions/competitions.state';
import {ClubState} from './club/club.state';
import {LegalDocumentsState} from './legal-documents/legal-documents.state';
import {StreamState} from './ott-stream/stream.state';
import {GlobalPageElementState} from './global-page-element/global-page-element-state.service';
import {CurrentClientState} from './current-client/current-client.state';
import {FormatEventsState} from './format-events/format-events.state';
import {PlaylistEventsState} from './playlist-events/playlist-events.state';
import {NgxsReduxDevtoolsPluginModule} from '@ngxs/devtools-plugin';
import {NgxsActionsExecutingModule} from '@ngxs-labs/actions-executing';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgxsModule.forRoot(
      [
        AuthState,
        UserState,
        PageTemplateState,
        EventState,
        LinkedEventsState,
        PlaylistState,
        FormatState,
        SearchEventsState,
        OfferItemsState,
        EntitlementsState,
        FeaturedEventsState,
        BlockedCountiresState,
        ClubsState,
        CompetitionsState,
        SeasonsState,
        StagesState,
        StandingsState,
        ClubState,
        LegalDocumentsState,
        StreamState,
        GlobalPageElementState,
        CurrentClientState,
        FormatEventsState,
        PlaylistEventsState,
      ],
      {
        developmentMode: !environment.production,
      },
    ),
  ],
})
export class StoreModule {}
